import { render, staticRenderFns } from "./SoundUploadPopup.vue?vue&type=template&id=5274a430&scoped=true"
import script from "./SoundUploadPopup.vue?vue&type=script&lang=ts"
export * from "./SoundUploadPopup.vue?vue&type=script&lang=ts"
import style0 from "./SoundUploadPopup.vue?vue&type=style&index=0&id=5274a430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274a430",
  null
  
)

export default component.exports